import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "@tanstack/react-router";

import { persistConsoleQueryCache } from "./lib/query-cache";
import { capturePageViews } from "./posthog";
import { createConsoleRouter } from "./router";
import "./styles.css";

/* The one router, with the one persisted cache. `createConsoleRouter` restores the
 * snapshot before it returns, so the first render is already the last known screen — for
 * everything except identity, which is never kept on disk and is always a door call. */
const router = createConsoleRouter(undefined, persistConsoleQueryCache);

/* Navigation is a product fact, so the product states it — here, at the composition root,
 * for the same reason persistence is injected rather than assumed: a suite that builds its
 * own router does not inherit the browser's analytics. A build with no PostHog settings
 * captures nothing and still navigates. */
capturePageViews(router);

/* A project's address opens with its rail's agent tree, a chunk of its own. The shell's own
 * module asks for it too, but that module arrives only after the identity read, and the
 * tree then mounts before its chunk is here: React holds a suspended reveal for 300 ms and
 * the rail paints without its agents. Asked for here, at the entry, it is here first. */
if (/^\/p\/[^/]+\/[^/]+(\/|$)/.test(window.location.pathname)) {
  void import("./workspaces/agents/ChatsRailTree");
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
